// extracted by mini-css-extract-plugin
export default {"table":"styles_table__jsqoZ","dragging":"styles_dragging__GYtZ8","headingRow":"styles_heading-row__6W452","draggingOver":"styles_dragging-over__J71gM"};